// Представляет желаемый маршрут, задаваемый пользователем.

import {uniqueByConsecutiveValues} from "../bl/routeService";

class RouteRequest {
  /** @param {Object} data
   * @param {RouteRequestPoint} data.from
   * @param {RouteRequestPoint} data.to
   * @param {RouteRequestPoint[]} data.through
   */
  constructor({from, to, through}) {
    through = uniqueByConsecutiveValues(through); // только уникальные точки
    
    /** Откуда
     * @type {RouteRequestPoint}
     * */
    this.from = from;
    /** Куда
     * @type {RouteRequestPoint} */
    this.to = to;
    /** Промежуточные точки (ехать через)
     * @type {RouteRequestPoint[]} */
    this.through = through;
  }
  
  /** @param {RouteRequest} routeRequest 
   * @returns {RouteRequestPoint[]} 
   */
  static getAllRoutePoints(routeRequest) {
    return [routeRequest.from, ...routeRequest.through, routeRequest.to];
  }
}

export default RouteRequest;